import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { Order, ParkingOrder } from '../models/orderModel';
import { OrderShuttle } from '../models/ShuttleBookingModel';

@Injectable({
  providedIn: 'root'
})
export class CheckoutService {
  hostPath: string = JSON.parse(environment.IDENTITY);
  orderId: string;
  order: Order;

  constructor(public router: Router, private http: HttpClient) {}

  public getOrder(orderId: string): Observable<Order> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/checkout/getorder/${orderId}`;
    return this.http.get<Order>(URL).pipe(
      map(order => {
        this.orderId = orderId;
        this.order = order;
        return order;
      }),
      catchError(this.handleError)
    );
  }

  public getTransaction(transactionId: string): Observable<Order> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/checkout/gettransaction/${transactionId}`;
    return this.http.get<Order>(URL).pipe(
      map(transaction => {
        return transaction;
      }),
      catchError(this.handleError)
    );
  }

  public orderParkingsOrder(orderId: string): Observable<ParkingOrder> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/orderparking/orderparkingsorderid?orderId=${orderId}`;
    return this.http.get<ParkingOrder>(URL).pipe(
      map(parkingOrder => {
        return parkingOrder;
      }),
      catchError(this.handleError)
    );
  }

  public orderShuttlesOrder(orderId: string): Observable<OrderShuttle[]> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/ordershuttle/ordershuttlesorderid/${orderId}`;
    return this.http.get<OrderShuttle[]>(URL).pipe(
      map(shuttleOrder => {
        return shuttleOrder;
      }),
      catchError(this.handleError)
    );
  }

  private handleError(error: Response | any) {
    const errMsg = error.message
      ? error.message
      : error.status
      ? `${error.status} - ${error.statusText}`
      : 'Server error';
    console.error(`checkoutService.handleError ${errMsg}`);
    return throwError(error);
  }
}
